import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"
import { initInvestmentCalculatorPage } from "./lib/investment_calculator"
import { initContributionPlannerPage } from "./lib/contribution_planner"

console.info("Bridgetown is loaded!", components)

document.addEventListener("DOMContentLoaded", () => {
  initInvestmentCalculatorPage()
  initContributionPlannerPage()
})
